export class RegexConstants {
  public static readonly DIGIT_UPTO_TWO_DECIMAL: RegExp = /^\d+\.?\d{0,2}$/;
  public static readonly DIGIT_WITH_NO_DECIMAL: RegExp = /^\d+$/;
  public static readonly WORK_ORDER_NUMBER: RegExp = /\b5\d{8}\b/g;
  public static readonly EQUIPMENT_NUMBER = /^[A-Za-z0-9\-]+$/;
  /** ✅ Shop Code: exactly 3 alphanumeric characters (letters or digits) */
  public static readonly SHOP_CODE: RegExp = /^[a-zA-Z0-9]{3}$/;

  /** ✅ Repair Mode: exactly 2 digits (e.g., "03", "10") */
  public static readonly REPAIR_MODE: RegExp = /^\d{2}$/;

  /** ✅ Repair Code: exactly 4 alphanumeric uppercase characters (e.g., "A123", "B5D7") */
  public static readonly REPAIR_CODE: RegExp = /^[A-Z0-9]{4}$/;
}
